import React, { useEffect,useCallback, useRef,useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import BulkUploadModal from './BulkUploadModal.js';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';



function Masters() {
    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([
        {
            headerName: "Action",
            field: "_id",
            resizable: true,
            width: 90,
            filter: false,
            cellRenderer: EditItem,
            pinned: "left",
                headerClass: 'bold-header'
            // editable: false
        },
        {
            headerName: "",
            field: "_id",
            width: 50,
            cellRenderer: DeletePartner,
            pinned: "left",
                headerClass: 'bold-header'
        },
       
        // {
        //     headerName: "Created Date",
        //     field: "created_date",
        //     width: 220,
        //     type: "datetime",
        //     filter: true,
        //     valueGetter: (params) => {
        //         if (!params.value) return '';
        //         const date = new Date(params.value);
        //         return format(date, 'dd-MM-yyyy');
        //     },
        // }
    
    ])
    const [ fuelTypeList, setFuelTypeList] = useState([
            {label:"Diesel", value:"Diesel"},
            {label:"EV", value:"EV"},
            {label:"CNG", value: "CNG"},
            {label:"Rail", value:"Rail"},
            {label:"Air", value:"Air"},
            {label:"Sea", value:"Sea"},
        ]);
    var transporterMasterColumns =[
        {
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 240,
            filter: true,
            editable: true, // Make the field editable
            valueGetter: function (params) {
                // Ensure a valid transporter name is returned
                if (params.data.transporter_name && params.data.transporter_name.trim() !== "") {
                    return params.data.transporter_name;
                } else {
                    return "";
                }
            },
            valueSetter: function (params) {
                const newValue = params.newValue;
                if (newValue && newValue.trim() !== "") {
                    params.data.transporter_name = newValue;
                    return true; // Accept the change
                } else {
                    params.data.transporter_name = ""; // Clear the field if invalid
                    return false; // Reject the change
                }
            },
            cellStyle: function (params) {
                // Highlight the cell with a red background if transporter_name is empty
                if (!params.value || params.value.trim() === "") {
                    return {
                        backgroundColor: "#c85f62", // Light red background for empty transporter_name
                        // color: "#fff" // Optional: White text for better contrast
                    };
                }
                return null; // No special styling for valid transporter_name
            },
            headerClass: 'bold-header'
        },
    
        {
            headerName: "Transporter Type",
            field: "transporter_type",
            width: 240,
            filter: true,
            editable: true,
        
            // ✅ valueGetter: Returns only valid transporter types (formatted correctly)
            valueGetter: function (params) {
                let transporterValue = params.data.transporter_type ? params.data.transporter_type.trim() : "";
                const validTransporterTypes = ["FTL", "PTL", "FTL/PTL"];
        
                // Convert input to uppercase for case-insensitive comparison
                transporterValue = transporterValue.toUpperCase();
        
                return validTransporterTypes.includes(transporterValue) ? transporterValue : "";
            },
        
            // ✅ valueSetter: Accepts lower/upper case but stores only uppercase
            valueSetter: function (params) {
                let newValue = params.newValue ? params.newValue.trim() : "";
                const validTransporterTypes = ["FTL", "PTL", "FTL/PTL"];
        
                // Convert input to uppercase for case-insensitive comparison
                newValue = newValue.toUpperCase();
        
                if (validTransporterTypes.includes(newValue)) {
                    params.data.transporter_type = newValue; // Store only uppercase values
                    return true; // Accept the change
                } else {
                    params.data.transporter_type = ""; // Clear the value if invalid
                    return false; // Reject the change
                }
            },
        
            // ✅ cellStyle: Highlights invalid values with red background
            cellStyle: function (params) {
                const transporterValue = params.value ? params.value.trim().toUpperCase() : "";
                const validTransporterTypes = ["FTL", "PTL", "FTL/PTL"];
        
                if (!validTransporterTypes.includes(transporterValue) && transporterValue !== "") {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid values
                        // color: "#fff" // White text for better contrast
                    };
                }
                return null; // Default style for valid values
            },
        
            headerClass: 'bold-header'
        }
        ,
        
    
        {
            headerName: "Tracking Type",
            field: "tracking_type",
            width: 240,
            filter: true,
            editable: true,
            valueGetter: (params) => {
                // Validate and return the tracking type
                const trackingValue = params.data.tracking_type;
                const validTrackingTypes = ["API", "SIM TRACKING", "MANUAL UPLOAD"];
                if (validTrackingTypes.includes(trackingValue.toUpperCase())) {
                    return params.data.tracking_type;
                } else {
                    return ""; // Return empty if invalid
                }
            },
            valueSetter: (params) => {
                const newValue = params.newValue?.trim();
                const validTrackingTypes = ["API", "SIM TRACKING", "MANUAL UPLOAD"];
                if (validTrackingTypes.includes(newValue.toUpperCase())) {
                    params.data.tracking_type = newValue; // Save the valid value
                    return true; // Accept the change
                } else {
                    params.data.tracking_type = ""; // Clear the value if invalid
                    return false; // Reject the change
                }
            },
            cellStyle: (params) => {
                // Highlight invalid tracking types with a red background
                if (!params.value || params.value.trim() === "") {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid values
                        // color: "#fff" // Optional: White text for contrast
                    };
                }
                return null; // Default style for valid values
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Fuel Type",
            field: "fuel_type",
            width: 240,
            filter: true,
            editable: true,
            valueGetter: (params) => {
                const fuelValue = params.data.fuel_type?.trim();
                const validfuelTypes = ["Diesel", "EV", "CNG", "Rail", "Air", "Sea"];
                
                if (fuelValue) {
                    const fuelTypesArray = fuelValue.split(',').map(item => item.trim());
                    const validFuelTypesArray = fuelTypesArray.filter(type => validfuelTypes.some(validType => validType.toLowerCase() === type.toLowerCase()));
                    return validFuelTypesArray.join(', '); // Return only valid fuel types as comma-separated string
                }
                return params.data.fuel_type || ""; // Return empty if no valid fuel types
            },
            valueSetter: (params) => {
                const newValue = params.newValue?.trim();
                const validfuelTypes = ["Diesel", "EV", "CNG", "Rail", "Air", "Sea"];
                
                if (newValue) {
                    const newFuelTypesArray = newValue.split(',').map(item => item.trim());
                    const validFuelTypesArray = newFuelTypesArray.filter(type => 
                        validfuelTypes.some(validType => validType.toLowerCase() === type.toLowerCase())
                    );
            
                    params.data.fuel_type = newFuelTypesArray.join(', '); // Keep the full typed value
                    return true; // Accept change
                }
            
                return false; // Reject change if empty
            },
            
            cellStyle: (params) => {
                if (!params.value || params.value.trim() === "") {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid values
                        // color: "#fff" // Optional: White text for contrast
                    };
                }
                return null; // Default style for valid values
            
            },
            headerClass: 'bold-header'

            
            
        }        
        
        
        
        
        
    ]
    var transporterMasterColumns1 =[
        {
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 240,
            filter: true,
            resizable:true
        },
    
        {
            headerName: "Transporter Type",
            field: "transporter_type",
            width: 240,
            filter: true,
            editable: true,
            resizable:true

        },
        
    
        {
            headerName: "Tracking Type",
            field: "tracking_type",
            width: 240,
            filter: true,
            editable: true,
            resizable:true

        },
        {
            headerName: "Fuel Type",
            field: "fuel_type",
            width: 240,
            filter: true,
            editable: true,
            resizable:true,
            valueFormatter: (params) => params.value ? params.value.join(", ") : "" 
        },
         {
            headerName: "Email",
            field: "email",
            width: 300,
            filter: true,
            resizable: true,
            valueFormatter: (params) =>
                params.value ? params.value.join(", ") : ""
        },
        {
            headerName: "CC Email",
            field: "cc_email",
            width: 300,
            filter: true,
            resizable: true,
            valueFormatter: (params) =>
                params.value ? params.value.join(", ") : ""
        },
        {
            headerName: "Alt To Email",
            field: "alt_to_email",
            width: 300,
            filter: true,
            resizable: true,
            valueFormatter: (params) =>
                params.value ? params.value.join(", ") : ""
        },
        {
            headerName: "Alt CC Email",
            field: "alt_cc_email",
            width: 300,
            filter: true,
            resizable: true,
            valueFormatter: (params) =>
                params.value ? params.value.join(", ") : ""
        }  
        
    ]

    var [columnDefs, setColumnDefs] = useState([...columnDefs1, ...transporterMasterColumns1])
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")

    };

    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid ,setRowId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [transporter_name, settransportername] = useState("");
    var [transporter_type, settransportertype] = useState("");
    var [tracking_type, settrackingtype] = useState({label: "API", value: "API"});
    var [fuel_type, setfueltype] = useState([]);
    const [email, setEmail] = useState([]);
    const [cc_email, setCcEmail] = useState([]);
    const [alt_to_email, setAltToEmail] = useState([]);
    const [alt_cc_email, setAltCcEmail] = useState([]);
    var [transporter_length, setTransporterLength] = useState("");
    var [is_active, setstatus] = useState("");
    const [selectTransporterType, setSelectTransporterType] = useState({label: "FTL", value: "FTL"})
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    
    
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);

    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable:true,
            sortable: true,
            filter: true,
            editable:false

        };
    }, []);

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        loadData();

        // 
    }, [])

    var loadData = async () => {
        var parameters = {}
        await redirectURL.post('/transporterlist', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    setRowData(response.data.records);
                    setTransporterLength(response.data.records.length);
                }
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
    }

    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        // console.log("Rownode Update", rownode);
        var params = {
            transporter_code: deleteRowData.data.transporter_code
        }
    
        try {
            const resp = await redirectURL.post('/deleteTransporterDetails', params);
            console.log(resp,"resp",resp.data.status,"success");
            
            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("Transporter Deleted Successfully");
                setBasicType("success");
                loadData();
            }
        } catch (error) {
            console.error("Error deleting transporter details:", error);
        }
    };
    var hideDeleteSubmit = ()=>{
        setDeleteConfirmationSlide("");
        setoverlay("show-n");
    
    }
    

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add Transporter");
        settransportername("");
        settransportertype("");
        setSelectTransporterType({label: "FTL", value: "FTL"})
        settrackingtype({label: "API", value: "API"});
        setIsEditMode(false);
        setEmail([]);
        setCcEmail([]);
        setAltToEmail([]);
        setAltCcEmail([]);

    }

    var onClickEditBlock  = async (rownode) =>{
        console.log("rownode ", rownode)

        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit Transporter");
        setRowId(rownode.data._id);
        settransportername(rownode.data.transporter_name);
        settransportertype(rownode.data.transporter_type);
        setSelectTransporterType({label: rownode.data.transporter_type, value: rownode.data.transporter_type})
        settrackingtype({label: rownode.data.tracking_type, value: rownode.data.tracking_type});
        const formattedFuelType = rownode.data.fuel_type.map(fuel=> ({label:fuel, value: fuel}))
        setfueltype(formattedFuelType)
        setIsEditMode(true);
        const formattedEmails =rownode.data.email?.map(mail => ({label: mail,value: mail})) || [];
        setEmail(formattedEmails);
        const formattedCcEmails = rownode.data.cc_email?.map(mail => ({label: mail,value: mail})) || [];
        setCcEmail(formattedCcEmails);
        const formattedAltToEmails = rownode.data.alt_to_email?.map(mail => ({label: mail,value: mail})) || [];
        setAltToEmail(formattedAltToEmails);
        const formattedAltCcEmails = rownode.data.alt_cc_email?.map(mail => ({label: mail,value: mail})) || [];
        setAltCcEmail(formattedAltCcEmails);
    }
    

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
    }
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }

    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");

    var saveMasterForm = async (e) => {
        e.preventDefault();
        let localStorageEmail = localStorage.getItem('email');
        let user_email = decode(localStorageEmail);
        let emailList = email.map(e => e.value);
        let ccEmailList = cc_email.map(e => e.value);
        let altToEmailList = alt_to_email.map(e => e.value);
        let altCcEmailList = alt_cc_email.map(e => e.value);
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        setshowloader("show-m")
        let fuelType= fuel_type.map(e=>e.value)
        if(isEditMode) {
            var params = {
                rowid: rowid,
                transporter_name: transporter_name,
                tracking_type: tracking_type.value,
                transporter_type: selectTransporterType.value,
                // is_active: is_active,
                modified_date: createdDate,
                fuel_type:fuelType,
                email: emailList,
                cc_email: ccEmailList,
                alt_to_email: altToEmailList,
                alt_cc_email: altCcEmailList,
                modified_by: user_email,
                
            }
        }
        else {
            var params = {
                transporter_name: transporter_name,
                tracking_type: tracking_type.value,
                transporter_type: selectTransporterType.value,
                // is_active: is_active,
                created_date: createdDate,
                fuel_type:fuelType,
                transporter_code: `T${transporter_length + 1}`,
                email: emailList,
                cc_email: ccEmailList,
                alt_to_email: altToEmailList,
                alt_cc_email: altCcEmailList,
                created_by: user_email
            }
        }
        
        console.log(params, "params");
        console.log(isEditMode, "edit mode");
        if (isEditMode) {
            await redirectURL.post('/updatetransporterdata', params).then((resp) => {
                console.log(resp, "edit response");
                if (resp.data.status === "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    settransportertype("");
                    settrackingtype({label: "API", value: "API"});
                    setstatus("");
                    setIsEditMode(false);
                    setRowId("");
                    setShow(true);
                    setBasicTitle("Updated Transporter Data");
                    setBasicType("success");
                    loadData();
                    setSelectTransporterType({label:"FTL", value:"FTL"})
                }
            });
        } else {
            if(params.transporter_name !=="" && params.tracking_type !=="" && params.transporter_type!==""){
                await redirectURL.post('/addtransporter', params).then((resp) => {
                    if (resp.data.status === "success") {
                        setoverlay("show-n");
                        setshowAddSlider("");
                        settransportertype("");
                        settrackingtype({label: "API", value: "API"});
                        setstatus("");
                        setIsEditMode(false);
                        setShow(true);
                        setBasicTitle("Added Transporter Data");
                        setBasicType("success");
                        loadData();
                        setSelectTransporterType({label:"FTL", value:"FTL"})

                    } else if (resp.data.status === "failure") {
                        setoverlay("show-n");
                        setshowloader("show-n");
                        setIsEditMode(false);
                        setshowAddSlider("");
                        settransportertype("");
                        settrackingtype({label: "API", value: "API"});
                        setstatus("");
                        setShow(true);
                        setBasicTitle(resp.data.message);
                        setBasicType("danger");
                        setSelectTransporterType({label:"FTL", value:"FTL"})

                    }
                }).catch(err => {
                });            
            }else{
                setShow(true);
                setBasicTitle("Please fill all the mandatory fields");
                setBasicType("danger");
            }
           
        }
    };

    var handleTransporterName = (e) => {
        var inputValue = e.target.value;
        if (inputValue != "") {
                if (inputValue.length <= 100) {
                    settransportername(inputValue)
                }
        }
        else {
            settransportername("");
        }
    };


    var handleTrackingType = (e) => {
        // if (isEditMode) return;
    
        // var inputValue = e.target.value;
        settrackingtype(e);

        // var validInput = inputValue.replace(/[^A-Z]/g, '');
    
        // if (validInput.length <= 10) {
        //     settrackingtype(validInput);
        // } else {
        //     settrackingtype("");
        // }
    } 
    var handleFuelType = (e) => {
        setfueltype(e);
        }    

    // var handleTrackingType = (e) => {
    //     // if (isEditMode) return;

    //     var inputValue = e.target.value;
    //     if (inputValue != "") {
    //         var isValid = /^[A-Za-z ]*$/;
    //         if (isValid.test(inputValue)) {
    //             if (inputValue.length <= 100) {
    //                 settrackingtype(inputValue)
    //             }
    //         }
    //     }
    //     else {
    //         settrackingtype("");
    //     }
    // }

    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
    {/* Row for Heading and Buttons */}
    <div className="row align-items-center justify-content-between" style={{ marginBottom: "10px" }}>
        {/* Heading */}
        <div className="col-auto">
            <h5 className="f18 d-flex align-items-center master-title">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>&nbsp;Transporter Master
            </h5>
        </div>

        {/* Buttons */}
        <div className="col-auto d-flex">
            <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning mr-2"
                type="button"
                style={{ padding: "8px 15px", height: "35px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;Upload Transporters
            </button>

            <BulkUploadModal
                show={showBulkUploadModal}
                onClose={closeBulkUploadModal}
                columnDefs={transporterMasterColumns}
                screen={"transporter"}
                templateUrl={require('../../assets/json/transporter_master_template.csv')}
            />

            {Constants.VEHICLES.BTN_ADD === 1 && (
                <button
                    className="btn btn-warning"
                    onClick={showAddBlock}
                    style={{ padding: "8px 15px", height: "35px" }}
                >
                    <i className="icon-plus"></i>&nbsp;Add Transporter
                </button>
            )}
        </div>
    </div>

    {/* Main Card and Grid */}
    <div className="row">
        <div className="col-xl-12 col-md-12 xl-60">
            <div className="card">
                <div className="card-body">
                    <div
                        className={"ag-theme-balham mt-8"}
                        style={{ height: "500px", width: "100%", paddingTop: "1rem" }}
                    >
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            paginationPageSize={50}
                            onGridReady={onGridReadyConsignments}
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                            masterDetail={true}
                            context={{ onClickEditBlock, onClickDeleteItem }}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        labelKey: "columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel",
                                        toolPanelParams: {
                                            suppressPivotMode: true,
                                            suppressRowGroups: true,
                                            suppressValues: true,
                                        },
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        labelKey: "filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel",
                                    },
                                ],
                            }}
                            statusBar={{
                                statusPanels: [
                                    {
                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                        align: "left",
                                    },
                                    {
                                        statusPanel: "agTotalRowCountComponent",
                                        align: "center",
                                    },
                                    { statusPanel: "agFilteredRowCountComponent" },
                                    { statusPanel: "agSelectedRowCountComponent" },
                                    { statusPanel: "agAggregationComponent" },
                                ],
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

            {/* <div className={"overlay-part " + (overlay)} onClick={hideAll}></div> */}

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                <h4 className="slide-r-title">{sliderText}
                <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transporter Name<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="transporter_name" value={transporter_name} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }} 
                            autoComplete='off'
                            onChange={handleTransporterName} required />
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transporter Type<span style={{ color: 'red' }}>*</span></label>
                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={selectTransporterType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={e => setSelectTransporterType(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={[
                                                    { label: "PTL", value: "PTL"},
                                                    { label: "FTL", value: "FTL"},
                                                    { label: "FTL/PTL", value: "FTL/PTL"},
                                                ]}
                                                required />
                            
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Tracking Type<span style={{ color: 'red' }}>*</span></label>
                            {/* <input
                                type="text"
                                name="tracking_type"
                                id="tracking_type"
                                value={tracking_type}
                                onChange={handleTrackingType}
                                required
                                // disabled={isEditMode}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                            /> */}
                             <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={tracking_type}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={e => handleTrackingType(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={[
                                                    { label: "API", value: "API"},
                                                    { label: "SIM Tracking", value: "Sim Tracking"},
                                                    { label: "Manual Upload", value: "Manual Upload"},
                                                ]}
                                                required />
                           
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Fuel Type<span style={{ color: 'red' }}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={false}
                                                value={fuel_type}
                                                onChange={e => handleFuelType(e)}
                                                isMulti={true}
                                               
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={fuelTypeList}
                                                required
                                            />
                                        </div>
                        <div className="form-group">
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "5px"
                                }}
                            >
                                Email
                            </label>

                            <CreatableSelect
                                isMulti
                                value={email}
                                onChange={(e) => setEmail(e)}
                                placeholder="Type email and press enter"
                                noOptionsMessage={() => null}
                                formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                isValidNewOption={(inputValue) => {
                                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: "100%",
                                        fontSize: "0.9rem"
                                    })
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "5px"
                                }}
                            >
                                CC Email
                            </label>

                            <CreatableSelect
                                isMulti
                                value={cc_email}
                                onChange={(e) => setCcEmail(e)}
                                placeholder="Type CC email and press enter"
                                noOptionsMessage={() => null}
                                formatCreateLabel={(inputValue) =>
                                    `Add "${inputValue}"`
                                }
                                isValidNewOption={(inputValue) => {
                                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: "100%",
                                        fontSize: "0.9rem"
                                    })
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "5px"
                                }}
                            >
                                Alt To Email
                            </label>

                            <CreatableSelect
                                isMulti
                                value={alt_to_email}
                                onChange={(e) => setAltToEmail(e)}
                                placeholder="Type Alt To email and press enter"
                                noOptionsMessage={() => null}
                                formatCreateLabel={(inputValue) =>
                                    `Add "${inputValue}"`
                                }
                                isValidNewOption={(inputValue) => {
                                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: "100%",
                                        fontSize: "0.9rem"
                                    })
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "5px"
                                }}
                            >
                                Alt CC Email
                            </label>

                            <CreatableSelect
                                isMulti
                                value={alt_cc_email}
                                onChange={(e) => setAltCcEmail(e)}
                                placeholder="Type Alt CC email and press enter"
                                noOptionsMessage={() => null}
                                formatCreateLabel={(inputValue) =>
                                    `Add "${inputValue}"`
                                }
                                isValidNewOption={(inputValue) => {
                                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: "100%",
                                        fontSize: "0.9rem"
                                    })
                                }}
                            />
                        </div>

                        {isEditMode ? 
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Update Transporter</button>
                        </div>
                        </>
                        :
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div>
                        </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                 && 
                 <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                    <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                </div>

                </div>}

            <div className={"dataLoadpage " +(showloader)}>
                </div>
                <div className={"dataLoadpageimg " +(showloader)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part "+(overlay)} onClick={hideAll}></div>


        </div>
    );
}

export default Masters;

